import { NgModule } from '@angular/core';
import { GamesRouting } from './games.routing';
import { RouterModule } from '@angular/router';
import { GameApplicationsService, GamesService, LineupsService, RatingService } from '@games/infra';
import { GameDetailsQueryHandler } from './application/handlers';

@NgModule({
  imports: [RouterModule.forChild(GamesRouting)],
  providers: [GamesService, GameDetailsQueryHandler, GameApplicationsService, RatingService, LineupsService]
})
export class GamesModule {}
